<template>
  <div class="bulk-delete" :style="`width: calc(100vw - ${panelWidth}px)`">
    <pageTabHeader>
      <h5>Bulk Delete</h5>
      <pageTabs @input="handleTabClick" @setTab="setTab" />
    </pageTabHeader>
    <tabContent :resetScroll="resetScroll">
      <loadingTab v-if="isLoading" />
      <div v-else>
        <configTab :tab="activeTab" />
      </div>
    </tabContent>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import configTab from "@/components/bulkUpdate/config-tab/delete-config-tab";
import pageTabHeader from "@/components/page-tab-header";
import pageTabs from "@/components/client/page-tabs";
import tabContent from "@/components/tab-content";

import loadingTab from "@/components/bulkUpdate/loadingTab";

import tabData from "@/components/client/tabData";

export default {
  components: {
    configTab,
    pageTabHeader,
    pageTabs,
    tabContent,
    loadingTab,
  },
  data() {
    return {
      tab: "Profile",
      resetScroll: undefined,
      tabData,
    };
  },
  methods: {
    handleTabClick(tab) {
      this.$router.replace({ hash: "" });
      this.resetScroll = tab;
    },
    setTab(tab) {
      this.tab = tab;
    },
  },
  computed: {
    isLoading() {
      return (
        this.pendingCalls.includes("/client/template/retrieve") ||
        this.pendingCalls.includes("/client/retrieve")
      );
    },
    activeTab() {
      return tabData.find((tab) => tab.name === this.tab)["id"];
    },
    ...mapGetters({
      pendingCalls: "getPendingCallList",
      panelWidth: "getTotalPanelWidth",
    }),
  },
  mounted() {
    if (this.$route.params.tab) {
      this.tab = this.tabData.findIndex(
        (tab) => this.$route.params.tab === tab.id
      );
    }
  },
};
</script>

<style lang="scss" scoped>
.page-tab-header {
  flex-direction: column;
  padding-bottom: 0;
}
.bulk-delete {
  padding-bottom: 75px;
  $subheader-height: 105px;
  height: calc(100vh - $header-height - $subheader-height);
  transition: width 200ms;
  &::v-deep {
    .config-tab {
      margin: auto;
      max-width: 920px;
    }
    .v-tab {
      text-transform: none;
    }
  }
}
.tab-content {
  height: calc(100% - 74px);
}
</style>